

// import React, { useEffect, useState } from "react";
// import { Table, Select, Tooltip, Modal, Button, Card } from "antd";
// import { ApiURL } from "../../../services/apiConstants";
// import { post } from "../../../services/services";
// import { ErrorToast } from "../../../widgets/AppToast";
// import { formatDate } from "../../../utils/dateFormatter";

// const FeatureRequest = () => {
//   const [page_loader, set_page_loader] = useState(true);

//   const [company_id, set_company_id] = useState("");
//   const [company_list, set_company_list] = useState([]);

//   const [ship_id, set_ship_id] = useState(null);
//   const [ship_list, set_ship_list] = useState([]);

//   const [featureRequests, setFeatureRequests] = useState([]);

//   const [descrModal, setDescrModal] = useState({
//     visible: false,
//     text: "",
//   });


//   const COMPANY_LIST_API = () => {
//     post(ApiURL.all_company_lising, new FormData()).then((res) => {
//       if (res?.status) {
//         set_company_list(res.data || []);

//         if (res.data?.length > 0) {
//           const firstCompany = res.data[0].id;
//           set_company_id(firstCompany);

//           FEATURE_REQUEST_API(firstCompany);
//         }
//       }
//     });
//   };


//   const SHIP_LIST_API = (companyId) => {
//     const form = new FormData();
//     form.append("company_id", companyId);

//     post(ApiURL.get_ships_by_company, form).then((res) => {
//       if (res?.status) {
//         set_ship_list(res.ships || []);
//         set_ship_id(null); // Clear previous ship
//       }
//     });
//   };


//   const FEATURE_REQUEST_API = (companyId, shipId = null) => {
//     set_page_loader(true);

//     const FD = new FormData();
//     FD.append("company_id", companyId);

//     if (shipId) {
//       FD.append("ship_id", shipId);
//     }

//     post(ApiURL.feature_request_list_com, FD)
//       .then((res) => {
//         if (res?.status) {
//           setFeatureRequests(res.data?.requests || res.data || []);
//         } else {
//           ErrorToast("Error", res.message);
//         }
//       })
//       .finally(() => set_page_loader(false));
//   };

//   // Load company list on first load
//   useEffect(() => {
//     COMPANY_LIST_API();
//   }, []);

//   // When company changes
//   useEffect(() => {
//     if (company_id) {
//       SHIP_LIST_API(company_id);
//       FEATURE_REQUEST_API(company_id); 
//     }
//   }, [company_id]);


//   const showDescription = (record) => {
//     setDescrModal({ visible: true, text: record.description });
//   };


//   const columns = [
//     {
//       title: "Request ID",
//       dataIndex: "feature_id",
//       align: "center",
//     },
//     {
//       title: "Title",
//       dataIndex: "title",
//       align: "center",
//     },
//     {
//       title: "Description",
//       align: "center",
//       render: (record) => (
//         <Button type="link" onClick={() => showDescription(record)}>
//           View
//         </Button>
//       ),
//     },
//     {
//       title: "Created At",
//       dataIndex: "created_at",
//       align: "center",
//       render: (text) => formatDate(text),
//     },
//     {
//       title: "Ship Name",
//       dataIndex: "ship_name",
//       align: "center",
//     },
//   ];

//   return (
//     <div style={{ padding: "10px" }}>
//       <Card style={{ marginBottom: "20px" }}>
//         <div className="row">
//           {/* ----------- COMPANY SELECT ------------ */}
//           <div className="col-3">
//             <label>Select Company</label>
//             <Select
//               style={{ width: "100%" }}
//               value={company_id}
//               onChange={(value) => set_company_id(value)}
//             >
//               {company_list.map((company) => (
//                 <Select.Option key={company.id} value={company.id}>
//                   {company.company_name}
//                 </Select.Option>
//               ))}
//             </Select>
//           </div>

//           {/* ----------- SHIP SELECT ------------ */}
//           <div className="col-3">
//             <label>Select Ship (Optional)</label>
//             <Select
//               allowClear
//               style={{ width: "100%" }}
//               placeholder="All Ships"
//               value={ship_id}
//               onChange={(value) => {
//                 set_ship_id(value);

//                 if (!value) {
//                   FEATURE_REQUEST_API(company_id); // Load company-wide list
//                 } else {
//                   FEATURE_REQUEST_API(company_id, value); // Load ship-wise list
//                 }
//               }}
//             >
//               {ship_list.map(
//                 (ship) =>
//                   !ship.soft_delete && (
//                     <Select.Option key={ship.id} value={ship.id}>
//                       {ship.vessel_name}
//                     </Select.Option>
//                   )
//               )}
//             </Select>
//           </div>
//         </div>
//       </Card>

//       {/* ---------------- Page Title ---------------- */}
//       <h3>Feature Requests List</h3>

//       {/* ---------------- Table ---------------- */}
//       <Table
//         bordered
//         columns={columns}
//         dataSource={featureRequests}
//         loading={page_loader}
//         pagination={{ pageSize: 10 }}
//         rowKey="id"
//       />

//       <Modal
//         title="Description"
//         visible={descrModal.visible}
//         footer={null}
//         onCancel={() => setDescrModal({ visible: false, text: "" })}
//       >
//         <p>{descrModal.text}</p>
//       </Modal>
//     </div>
//   );
// };

// export default FeatureRequest;
import React, { useEffect, useState } from "react";
import { Table, Select, Modal, Button, Card } from "antd";
import { ApiURL } from "../../../services/apiConstants";
import { post } from "../../../services/services";
import { ErrorToast } from "../../../widgets/AppToast";
import { formatDate } from "../../../utils/dateFormatter";

const BASE_URL = process.env.REACT_APP_API_URL;

const FeatureRequest = () => {
  const [page_loader, set_page_loader] = useState(true);

  const [company_id, set_company_id] = useState(null);
  const [company_list, set_company_list] = useState([]);

  const [ship_id, set_ship_id] = useState(null);
  const [ship_list, set_ship_list] = useState([]);

  const [featureRequests, setFeatureRequests] = useState([]);

  /* ---------- DESCRIPTION MODAL ---------- */
  const [descrModal, setDescrModal] = useState({
    visible: false,
    text: "",
  });

  /* ---------- ATTACHMENT MODAL ---------- */
  const [attachmentModal, setAttachmentModal] = useState({
    visible: false,
    url: "",
  });

  /* ================= COMPANY LIST ================= */
  const COMPANY_LIST_API = () => {
    post(ApiURL.all_company_lising, new FormData()).then((res) => {
      if (res?.status) {
        set_company_list(res.data || []);
        FEATURE_REQUEST_API();
      }
    });
  };

  /* ================= SHIP LIST ================= */
  const SHIP_LIST_API = (companyId) => {
    const form = new FormData();
    form.append("company_id", companyId);

    post(ApiURL.get_ships_by_company, form).then((res) => {
      if (res?.status) {
        set_ship_list(res.ships || []);
        set_ship_id(null);
      }
    });
  };

  /* ================= FEATURE REQUEST LIST ================= */
  const FEATURE_REQUEST_API = (companyId = null, shipId = null) => {
    set_page_loader(true);

    const FD = new FormData();
    if (companyId) FD.append("company_id", companyId);
    if (shipId) FD.append("ship_id", shipId);

    post(ApiURL.feature_request_list_com, FD)
      .then((res) => {
        if (res?.status) {
          setFeatureRequests(res.data || []);
        } else {
          ErrorToast("Error", res.message);
        }
      })
      .finally(() => set_page_loader(false));
  };

  /* ================= FIRST LOAD ================= */
  useEffect(() => {
    COMPANY_LIST_API();
  }, []);

  /* ================= COMPANY CHANGE ================= */
  useEffect(() => {
    if (!company_id) {
      set_ship_list([]);
      set_ship_id(null);
      FEATURE_REQUEST_API();
      return;
    }

    SHIP_LIST_API(company_id);
    FEATURE_REQUEST_API(company_id);
  }, [company_id]);

  /* ================= HELPERS ================= */
  const showDescription = (record) => {
    setDescrModal({ visible: true, text: record.description });
  };

  const showAttachment = (path) => {
    setAttachmentModal({
      visible: true,
      url: `${BASE_URL}${path}`,
    });
  };

  /* ================= TABLE COLUMNS ================= */
  const columns = [
    {
      title: "Request ID",
      dataIndex: "feature_id",
      align: "center",
    },
    {
      title: "Title",
      dataIndex: "title",
      align: "center",
    },
    {
      title: "Description",
      align: "center",
      render: (record) => (
        <Button type="link" onClick={() => showDescription(record)}>
          View
        </Button>
      ),
    },
    {
      title: "Attachment",
      align: "center",
      render: (record) =>
        record?.attachment ? (
          <Button
            type="link"
            onClick={() => showAttachment(record.attachment)}
          >
            View
          </Button>
        ) : (
          "—"
        ),
    },
    {
      title: "Created At",
      dataIndex: "created_at",
      align: "center",
      render: (text) => formatDate(text),
    },
    {
      title: "Ship Name",
      dataIndex: "ship_name",
      align: "center",
    },
  ];

  return (
    <div style={{ padding: "10px" }}>
      {/* ---------------- FILTERS ---------------- */}
      <Card style={{ marginBottom: "20px" }}>
        <div className="row">
          {/* COMPANY */}
          <div className="col-3">
            <label>Select Company</label>
            <Select
              style={{ width: "100%" }}
              value={company_id}
              allowClear
              placeholder="All Companies"
              onChange={(value) => set_company_id(value)}
            >
              {company_list.map((company) => (
                <Select.Option key={company.id} value={company.id}>
                  {company.company_name}
                </Select.Option>
              ))}
            </Select>
          </div>

          {/* SHIP */}
          <div className="col-3">
            <label>Select Ship (Optional)</label>
            <Select
              allowClear
              style={{ width: "100%" }}
              placeholder="All Ships"
              value={ship_id}
              disabled={!company_id}
              onChange={(value) => {
                set_ship_id(value);
                value
                  ? FEATURE_REQUEST_API(company_id, value)
                  : FEATURE_REQUEST_API(company_id);
              }}
            >
              {ship_list.map(
                (ship) =>
                  !ship.soft_delete && (
                    <Select.Option key={ship.id} value={ship.id}>
                      {ship.vessel_name}
                    </Select.Option>
                  )
              )}
            </Select>
          </div>
        </div>
      </Card>

      {/* ---------------- TABLE ---------------- */}
      <h3>Feature Requests List</h3>

      <Table
        bordered
        columns={columns}
        dataSource={featureRequests}
        loading={page_loader}
        pagination={{ pageSize: 10 }}
        rowKey="id"
      />

      {/* ---------------- DESCRIPTION MODAL ---------------- */}
      <Modal
        title="Description"
        open={descrModal.visible}
        footer={null}
        onCancel={() => setDescrModal({ visible: false, text: "" })}
      >
        <p>{descrModal.text}</p>
      </Modal>

      {/* ---------------- ATTACHMENT MODAL ---------------- */}
      <Modal
        title="Attachment Preview"
        open={attachmentModal.visible}
        footer={null}
        width={700}
        onCancel={() =>
          setAttachmentModal({ visible: false, url: "" })
        }
      >
        <img
          src={attachmentModal.url}
          alt="Attachment"
          style={{ width: "100%", borderRadius: "6px" }}
        />
      </Modal>
    </div>
  );
};

export default FeatureRequest;
